<!--
 * @Author: mzw
 * @Date: 2021-09-22 15:13:50
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2025-05-13 15:02:30
 * @Description: 地址编辑弹窗组件
-->
<template>
  <div class="addArea">
    <div class="add_form">
      <el-form
        ref="dataForm"
        label-width="110px"
        :model="dataForm"
        :rules="addressRule"
        :disabled="buttonLoading"
        label-position="right"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="收货人" prop="receiveGoodsPerson">
              <el-input
                v-model="dataForm.receiveGoodsPerson"
                placeholder="请输入"
                :maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收货人电话" prop="receiveGoodsPhone">
              <el-input
                v-model="dataForm.receiveGoodsPhone"
                placeholder="支持座机号码录入"
                :maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="所属区域：" prop="area">
          <el-cascader
            :options="region"
            clearable
            placeholder="请选择"
            :props="props"
            v-model="dataForm.area"
            style="width: 100%"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址：" prop="address">
          <el-input
            v-model="dataForm.address"
            placeholder="请输入详细地址"
            :maxlength="200"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="是否为默认：">
          <el-checkbox
            v-model="dataForm.defaultAddress"
            text-color="#333333"
            fill="#1D65A8"
            class="defaultbox"
          >
            默认地址
          </el-checkbox>
        </el-form-item>
      </el-form>
      <div
        @click="handleAddressSaved"
        class="saveAdd"
        v-loading="buttonLoading"
      >
        提交
      </div>
    </div>
  </div>
</template>
<script>
import validate from '@/utils/validate'
export default {
  data () {
    return {
      region: [],
      props: {
        label: 'name',
        value: 'name',
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node
          // 防止过载
          if (node.loaded) {
            resolve([])
            return
          }
          if (level === 1) {
            // 切换省
            this.getCity(data.codeP)
              .then((res) => {
                resolve(res)
              })
              .catch(() => {
                resolve([])
              })
          }
          if (level === 2) {
            // 切换市
            this.getArea(data.codeC)
              .then((res) => {
                resolve(res)
              })
              .catch(() => {
                resolve([])
              })
          }
        }
      },
      dataForm: {
        address: null,
        area: [],
        city: null,
        id: null,
        defaultAddress: true,
        province: null,
        receiveGoodsPerson: null,
        receiveGoodsPhone: null
      },
      buttonLoading: false
    }
  },
  props: {
    row: {
      type: Object,
      default: null
    }
  },
  computed: {
    addressRule () {
      return {
        area: [
          {
            required: true,
            type: 'array',
            message: this.$t('validate.required'),
            trigger: 'change'
          }
        ],
        address: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'change'
          }
        ],
        receiveGoodsPerson: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'change'
          }
        ],
        receiveGoodsPhone: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'change'
          },
          {
            validator: validate.validatePhoneTwo,
            trigger: 'change'
          }
        ]
      }
    }
  },
  methods: {
    handleClose2 () {
      this.$emit('handleClose2')
    },
    handleAddressSaved () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.doSubmit()
      })
    },
    doSubmit () {
      const obj = {
        ...this.dataForm,
        id: this.dataForm.id || undefined,
        companyId: this.$store.state.user.defaultCompanyId
      }
      if (obj.area instanceof Array && obj.area.length === 3) {
        obj.province = obj.area[0]
        obj.city = obj.area[1]
        obj.area = obj.area[2]
      }
      this.buttonLoading = true
      this.$http
        .post('/front/oms/plc/address/addOrUpdateAddress', obj)
        .then(({ data: res }) => {
          this.buttonLoading = false
          if (res.code === 0) {
            this.$message.success('操作成功')
            this.$emit('success')
          }
        })
    },
    // 获取省
    getProvince (call) {
      this.$http
        .get(`/front/sys/sysProvince/provinceList`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.region = res.data
            call && call()
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(() => {
          this.$message.error('获取省份失败')
        })
    },
    // 获取市
    getCity (codeP) {
      return this.$http
        .get(`/front/sys/sysProvince/cityList/${codeP}`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            return res.data
          } else {
            this.$message.error(res.msg)
            return []
          }
        })
        .catch(() => {
          this.$message.error('获取城市失败')
        })
    },
    // 获取区
    getArea (codeC) {
      return this.$http
        .get(`/front/sys/sysProvince/areaList/${codeC}`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            const leafData = res.data.map((item) => {
              return {
                ...item,
                leaf: true
              }
            })
            return leafData
          } else {
            this.$message.error(res.msg)
            return []
          }
        })
        .catch(() => {
          this.$message.error('获取区域失败')
        })
    }
  },
  mounted () {
    // 如果是编辑 要回显
    if (this.row.id) {
      this.dataForm = {
        address: this.row.address,
        area: [this.row.province, this.row.city, this.row.area],
        city: this.row.city,
        id: this.row.id,
        defaultAddress: this.row.defaultAddress || true,
        province: this.row.province,
        receiveGoodsPerson: this.row.receiveGoodsPerson,
        receiveGoodsPhone: this.row.receiveGoodsPhone
      }
      this.getProvince(() => {
        this.region.some((v) => {
          if (v.name === this.row.province) {
            // 获取市
            this.getCity(v.codeP).then((res) => {
              this.$set(v, 'children', res)
              res.some((v2) => {
                if (v2.name === this.row.city) {
                  this.getArea(v2.codeC).then((res2) => {
                    this.$set(v2, 'children', res2)
                  })
                  return true
                }
                return false
              })
            })
            return true
          }
          return false
        })
        this.region = [...this.region]
      })
    } else {
      this.getProvince()
    }
  }
}
</script>
<style lang="scss" scoped>
.saveAdd {
  width: 150px;
  height: 40px;
  background: #2a54d1;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  margin: 30px auto 0;
  cursor: pointer;
  border-radius: 8px;
}
</style>
